import React from 'react';


export class Button extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.generateState()
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props !== prevProps) {
            this.setState(this.generateState());
        }
    }

    generateState = () => {
        return {
            color: 'main',
            secondary: false,
            text: 'Button',
            icon: null,
            size: null,
            float: 'none',
            onClick: () => {},
            display: true,
            style: {},
            ...this.props
        };
    }

    getSize = () => {
        if (this.state.size === null) {
            return '';
        }

        return ' imd-button-' + this.state.size;
    }

    getClass = () => {
        if (this.state.secondary) {
            return 'imd-button imd-button-secondary imd-border-color-' + this.state.color + ' imd-text-' + this.state.color + this.getSize();
        }

        return 'imd-button imd-border-color-' + this.state.color + ' imd-bg-gradient-reverse-' + this.state.color + ' imd-text-180-' + this.state.color + this.getSize();
    }

    getStyle = () => {
        let styles = {
            ...this.state.style,
            display: this.state.display ? 'inline-block' : 'none',
            float: this.state.float
        };

        if (this.state.float === 'right' || this.state.marginRight) {
            styles.marginLeft = '7px';
        }

        return styles;
    }

    render() {
        return (
            <button
                className={this.getClass()}
                onClick={() => this.state.onClick()}
                style={this.getStyle()}
            >
                {this.state.icon !== null ?
                    <span className={this.state.icon} /> :
                    this.state.text
                }
            </button>
        );
    }
}
